import { getConfig } from '../config';
import { LOGIN_PATH } from '../constants/routes';
import { OAuthentication } from '../lib/Authentication';
import {
  deauthorizeAccount,
  fetchRefreshToken,
  getMe,
  postLogin,
  resetPassword,
  forgotPassword,
} from '../services/AccountService';
import history from './history';
import storage from './storage';

const defaultProps = {
  loginRequest: postLogin,
  getProfileRequest: getMe,
  refreshTokenRequest: fetchRefreshToken,
  deauthorizeRequest: deauthorizeAccount,
  navigateToLogin: () => history.push({ pathname: LOGIN_PATH }),
  roleType: getConfig('AUTH_ROLE_TYPE'),
  rolesAllowed: getConfig('AUTH_ROLES_ALLOWED'),
  forgotPasswordRequest: forgotPassword,
  resetPasswordRequest: resetPassword,
};

const Authentication = new OAuthentication({ storage, ...defaultProps });

export default Authentication;
